import React from "react";
import { reduxForm } from "redux-form";
import validate from "./validate";

const FormOne = props => {
	const { handleSubmit, change } = props;

	const [other, setOther] = React.useState(false);

	const handleSelect = event => {
		change("type", event.target.name);
		handleSubmit(event.target.name);
	};

	return (
		<div>
			<div className="flex-center">
				{/* <h3 className="account__title">Selecione uma opção:</h3> */}
			</div>
			{/* <button
				name="supporter"
				className="btn btn-primary account__btn account__btn--small"
				// onClick={handleSelect}
				disabled
			>
				INSCRIÇÕES ENCERRADAS
			</button> */}
			{other ? (
				<>
					<button
						name="supporter"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleSelect}
					>
						Apoiador
					</button>

					<button
						name="student"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleSelect}
					>
						Estudante
					</button>

					<button
						name="guest"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleSelect}
					>
						Visitante
					</button>

					<button
						name="back"
						className="btn btn-primary account__btn account__btn--small"
						onClick={() => setOther(false)}
					>
						Voltar
					</button>
				</>
			) : (
				<>
					<button
						name="defender"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleSelect}
					>
						Autodefensor(a)
					</button>
					<button
						name="director"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleSelect}
					>
						Diretoria
					</button>
					<button
						name="coordinator"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleSelect}
					>
						Coordenador(a)
					</button>
					<button
						name="exhibitor"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleSelect}
					>
						Expositor
					</button>
					<button
						name="professional"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleSelect}
					>
						Profissional
					</button>
					<button
						name="family"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleSelect}
					>
						Família
					</button>
					<button
						name="speaker"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handleSelect}
					>
						Palestrante
					</button>
					<button
						name="other"
						className="btn btn-primary account__btn account__btn--small"
						onClick={() => setOther(true)}
					>
						Outro
					</button>
				</>
			)}
		</div>
	);
};

export default reduxForm({
	form: "expositor_form",
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate: v => validate(v, 1)
})(FormOne);
